import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectTop, selectMaxTopValue } from './selectors'
import TopChart from 'reports/top/TopChart'
import { defineMessages, intlShape, injectIntl } from 'react-intl'
import { compose } from 'redux'
import ScrapTooltip from './ScrapTooltip'

const messages = defineMessages({
  title: {
    id: 'oee.locationScrapTop.title',
    defaultMessage: 'TOP 10 Scrap Types'
  }
})

const formatter = _intl => val => val

const ScrapTop = ({ data, maxValue, intl }) => {
  return (
    <div>
      <h2>{intl.formatMessage(messages.title)}</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {Object.entries(data).map(([month, dataSet]) => (
          <TopChart
            key={month}
            month={month}
            data={dataSet}
            maxValue={maxValue}
            tooltipContent={ScrapTooltip}
            formatter={formatter}
          />
        ))}
      </div>
    </div>
  )
}

ScrapTop.propTypes = {
  data: PropTypes.object,
  maxValue: PropTypes.number.isRequired,
  intl: intlShape
}

const mapStateToProps = state => ({
  data: selectTop(state),
  maxValue: selectMaxTopValue(state)
})

export default compose(
  connect(mapStateToProps),
  injectIntl
)(ScrapTop)
